import { useContext } from "react";
import TrackingContext, {
  TrackingContextState,
} from "@src/lib/contexts/TrackingContext";

export const useTracking = (): TrackingContextState => {
  return useContext(TrackingContext);
};
